import React from "react";
import AuthHeader from "../../../components/auth/AuthHeader/AuthHeader";
import AuthSlider from "../../../components/auth/authSlider/AuthSlider";
import { AuthSlides } from "../../../helpers/authConstants/AuthConstants";
import { Box } from "../../../components/styled/Elements";
import { Col, Row } from "react-bootstrap";
import { LoginWithPhoneWrapper } from "./styled";
import PhoneSigninForm from "./components/PhoneSigninForm";

const LoginWithPhone = () => {
  return (
    <LoginWithPhoneWrapper>
      <AuthHeader />
      <Box className="mt-4 container-fluid pb-4">
        <Row>
          <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 px-md-5">
            <PhoneSigninForm />
          </Col>
          <Col lg={6} md={6} sm={12} className="px-3 px-xl-5 auth-slider">
            <Box className="sticky-item">
              <AuthSlider slides={AuthSlides} />
            </Box>
          </Col>
        </Row>
      </Box>
    </LoginWithPhoneWrapper>
  );
};

export default LoginWithPhone;
